import React from 'react';

import { SVGComponentProps } from './svg.types';

const HeadingOneSVG = ({
  size = '1em',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps): JSX.Element => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherSvgProps}
      >
        <rect x="0.5" y="0.5" width="23" height="23" rx="1.5" fill="white" />
        <path d="M3 11H4.33V8.02378H7.54V11H8.88V4H7.54V6.97622H4.33V4H3V11Z" fill="#55585E" />
        <path
          d="M11.5198 11H12.8598V4H11.6698L10.0098 5.15524V6.3007L11.5198 5.29231V11Z"
          fill="#55585E"
        />
        <rect x="3" y="15" width="18" height="1" fill="#BCBEC2" />
        <rect x="3" y="17" width="18" height="1" fill="#BCBEC2" />
        <rect x="3" y="19" width="10" height="1" fill="#BCBEC2" />
        <rect x="0.5" y="0.5" width="23" height="23" rx="1.5" stroke="#D5D7DD" />
      </svg>
    </span>
  );
};

export default HeadingOneSVG;
